import { OMNI_COMM_AUTH_LOGIN_FAILURE, OMNI_COMM_AUTH_LOGIN_START, OMNI_COMM_AUTH_LOGIN_SUCCESS } from "../../actions/actionTypes";


const omniAuthLoginReducer = (initialState = {loading: false, data: null, error: null}, action) => {
    switch (action.type) {
        case OMNI_COMM_AUTH_LOGIN_START:
            return { ...initialState, loading: true };
        case OMNI_COMM_AUTH_LOGIN_SUCCESS:
            return {
                ...initialState,
                loading: false,
                data: action.payload
            }
        case OMNI_COMM_AUTH_LOGIN_FAILURE:
            return {
                ...initialState,
                loading: false,
                error: action.payload
            };
        default:
            return initialState;
    }
}

const omniRefreshTokenReducer = (initialState = {loading: false, data: null, error: null}, action) => {
    switch (action.type) {
        case OMNI_COMM_AUTH_LOGIN_START:
            return { ...initialState, loading: true };
        case OMNI_COMM_AUTH_LOGIN_SUCCESS:
            return {
                ...initialState,
                loading: false,
                data: action.payload
            }
        case OMNI_COMM_AUTH_LOGIN_FAILURE:
            return {
                ...initialState,
                loading: false,
                error: action.payload
            };
        default:
            return initialState;
    }
}

export {
    omniAuthLoginReducer,
    omniRefreshTokenReducer
};